export default __webpack_public_path__ + "static/media/processheader.2f68fb7c.jpg";